export const PERMS = {
    READ: 'carrier_scoring.read',
    UPDATE: 'carrier_scoring.update',
    DELETE: 'carrier_scoring.delete',
    CREATE: 'carrier_scoring.create',
}
